import Skeleton from "react-loading-skeleton";
import cancelIcon from "../../../assets/images/cancel-btn.svg";
import { useAppointmentReasons } from "../../../queries";

/** Appointment absence form. */
export function AbsenceModal({
  isOpen,
  reason,
  reasons: propReasons,
  isSubmitting,
  onClose,
  onReasonChange,
  onSubmit,
}) {
  const { data: fetchedReasons, isLoading: isLoadingReasons } = useAppointmentReasons(
    "absence",
    {
      enabled: Boolean(isOpen),
      staleTime: 5 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
    }
  );

  if (!isOpen) return null;

  const reasons =
    propReasons && propReasons.length > 0
      ? propReasons
      : fetchedReasons ?? [];
  const showSkeleton = isLoadingReasons && (!propReasons || propReasons.length === 0);

  return (
    <div className="popup holidayPopup">
      <div className="popup-content">
        <button
          aria-label="Close absence form"
          className="cancelBtn"
          onClick={onClose}
          type="button"
        >
          <img src={cancelIcon} alt="" />
        </button>
        <div className="addNursePopup">
          <h2 className="nurseHdn">Mark as Absense</h2>
          <ul>
            <li>
              <label htmlFor="consultation-absence-reason">
                What is reason of absense?
              </label>
              {showSkeleton ? (
                <div
                  className="SkelWrapper"
                  data-testid="absence-reason-skeleton"
                  style={{ marginTop: "8px", marginBottom: "8px" }}
                >
                  <Skeleton height={40} borderRadius={8} baseColor="#cfd5f9" />
                </div>
              ) : (
                <select
                  id="consultation-absence-reason"
                  aria-label="Absence reason"
                  value={reason ?? ""}
                  onChange={(event) => onReasonChange(event.target.value)}
                >
                  <option hidden value="">
                    Select reason here
                  </option>
                  {reasons.map((item, index) => (
                    <option key={item?.id ?? `${item?.name}-${index}`} value={item?.name}>
                      {item?.name}
                    </option>
                  ))}
                </select>
              )}
            </li>
            <li>
              <button disabled={isSubmitting || showSkeleton} onClick={onSubmit} type="button">
                {isSubmitting ? "Please wait..." : "Submit"}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
